import { api } from "@/apiInstance";
import { endpoints } from "@/endpoints";
import { courseBaseByIdQueryOptions, courseByIdQueryOptions } from "@/queries/courses";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EditCourseRequest } from "@vixi/types";

export const useEditCourse = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (body: EditCourseRequest) => {
    const response = await api.post(endpoints.editCourse, body);

    queryClient.invalidateQueries({
      queryKey: courseBaseByIdQueryOptions(queryClient, body.courseId).queryKey,
    });
    queryClient.invalidateQueries({
      queryKey: courseByIdQueryOptions(queryClient, body.courseId).queryKey,
    });

    return response.data as boolean;
  };

  return useMutation({
    mutationKey: ["edit-course"],
    mutationFn,
    retry: 2,
  });
};
